import { InjectionToken } from '@angular/core';

import { DatepickerInputDirective } from './datepicker-input.directive';

/**
 * This token is needed to inject the datepicker input directive into the datepicker calendar and allow
 * the calendar to read the datepicker input value and set the value.
 */
export const DATEPICKER_INPUT_DIRECTIVE = new InjectionToken<DatepickerInputDirective>('DATEPICKER_INPUT_DIRECTIVE');



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/datepicker-input/datepicker-input.token.ts